module.exports = __webpack_public_path__ + "img/btn-android.3d1ad071.png";